import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentFlowButtonComponent } from 'app/modules/shared/document-flow-button/document-flow-button.component';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * Actions Cell Renderer
 *
 * Renders action menu with document flow button
 *
 * @example
 * ```typescript
 * {
 *   headerName: 'Acciones',
 *   cellRenderer: ActionsCellRendererComponent,
 *   sortable: false,
 *   minWidth: 100,
 *   colId: 'actions'
 * }
 * ```
 */
@Component({
  selector: 'app-actions-cell-renderer',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    DocumentFlowButtonComponent,
  ],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="actionMenu"
      matTooltip="Acciones"
      (click)="$event.stopPropagation()">
      <mat-icon>more_vert</mat-icon>
    </button>
   <mat-menu #actionMenu="matMenu">
    <button mat-menu-item (click)="mapMenuItem()">
      <mat-icon svgIcon="heroicons_solid:map-pin" color="primary"></mat-icon>
      <span>Ver movimiento</span>
    </button>
  </mat-menu>
  `,
})
export class ActionsCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;

  mapMenuItem(): void {
    this.params.mapMenuItem?.(this.params.data);
  }  
}
